@if (isLoading()) {
  <div class="flex h-full items-center justify-center">
    <dojo-loader />
  </div>
} @else {
  <dojo-question
    [shouldShowRightSidebar]="true"
    [sidebarTemplateRef]="questionSelectorTemplate"
    [footerTemplateRef]="footerTemplate"
    (completed)="close()"
  />
}

<ng-template #questionSelectorTemplate>
  <div
    class="bg-neutral-0 z-2 sticky top-0 flex flex-col border-b border-neutral-200 md:static md:h-full md:max-h-[calc(100vh-76px)] md:border-b-0 md:border-r"
  >
    <dojo-challenge-review-question-selector [challengeActivityId]="challengeActivityId()" class="flex-1" />
  </div>
</ng-template>

<ng-template #footerTemplate>
  <small-layout>
    <dojo-footer-panel>
      <div class="right flex w-full flex-row items-center justify-end gap-2">
        <dojo-button
          fill="solid"
          (click)="close()"
          [ngClass]="state.isQuestionMultipleChoice ? 'mr-[96px] block w-full' : 'w-full md:min-w-[178px]'"
        >
          {{ 'exams.end' | transloco }}
        </dojo-button>
      </div>
    </dojo-footer-panel>
  </small-layout>
  <wide-layout>
    <dojo-footer-panel [limitWidthContainer]="false">
      <div right class="flex items-center justify-end gap-2">
        <dojo-button fill="solid" (click)="close()" class="w-full md:min-w-[178px]">
          {{ 'exams.end' | transloco }}
        </dojo-button>
      </div>
    </dojo-footer-panel>
  </wide-layout>
</ng-template>
